import { render, staticRenderFns } from "./safeProblem.vue?vue&type=template&id=4cfea038&"
import script from "@viewJs/home/safeProblem.js?vue&type=script&lang=js&"
export * from "@viewJs/home/safeProblem.js?vue&type=script&lang=js&"
import style0 from "./safeProblem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports